module.exports = __webpack_public_path__ + "static/img/moaUninstall_pic02.2bfebe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaUninstall/moaUninstall_pic02.png
// module id = 547
// module chunks = 1